import { useEffect, useRef, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import ProductCard from "./components/ProductCard";
import CartPanel from "./components/CartPanel";
import ProductDetails from "./pages/ProductDetails";
import Header from "./components/Header";
import CheckoutPage from "./pages/CheckoutPage";
import AdminOrdersPage from "./pages/AdminOrdersPage";
import AdminProductsPage from "./pages/AdminProductsPage";
import AdminAddProductPage from "./pages/AdminAddProductPage";
import AdminEditProductPage from "./pages/AdminEditProductPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminRoute from "./components/AdminRoute";
import OrderStatusPage from "./pages/OrderStatusPage";
import HeroBanner from "./components/HeroBanner";
import Footer from "./components/Footer";
import CataloguePage from "./pages/CataloguePage";
import { apiRequest } from "./services/api";




function HomePage({ products, addToCart, setSelectedCategory }) {
  function handleShopCollectionClick() {
    const productsSection = document.getElementById("products-section");
    if (productsSection) {
      productsSection.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }

  return (
    <div
      style={{
        padding: "30px",
        background: "#f7f8fa",
        minHeight: "100vh",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <HeroBanner onShopCollection={handleShopCollectionClick} />

      <div
        style={{
          display: "flex",
          gap: "12px",
          flexWrap: "wrap",
          marginBottom: "25px",
        }}
      >
        <button onClick={() => setSelectedCategory("All")} style={filterButtonStyle}>
          All
        </button>
        <button onClick={() => setSelectedCategory("Skin Care")} style={filterButtonStyle}>
          Skin Care
        </button>
        <button onClick={() => setSelectedCategory("Hair Care")} style={filterButtonStyle}>
          Hair Care
        </button>
        <button onClick={() => setSelectedCategory("Aloe Vera Products")} style={filterButtonStyle}>
          Aloe Vera
        </button>
      </div>

      <div
        id="products-section"
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: "20px",
          paddingRight: "90px",
        }}
      >
        {products.map((product) => (
          <ProductCard
            key={product.id}
            product={product}
            addToCart={addToCart}
          />
        ))}
      </div>

      <Footer />
    </div>
  );
}

const filterButtonStyle = {
  background: "white",
  border: "1px solid #d1d5db",
  padding: "10px 16px",
  borderRadius: "8px",
  cursor: "pointer",
  fontWeight: "bold",
  color: "#222",
};

function AppContent() {
  const location = useLocation();

  const [products, setProducts] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [search, setSearch] = useState("");
  const [cart, setCart] = useState([]);
  const [showCart, setShowCart] = useState(false);

  const hideTimer = useRef(null);

  const isAdminPage = location.pathname.startsWith("/admin");
  const isCataloguePage = location.pathname === "/catalogue";

  useEffect(() => {
    apiRequest("/products")
      .then((data) => setProducts(data));
  }, []);

  useEffect(() => {
    function handleClickOutside() {
      setShowCart(false);
    }

    if (showCart && !isAdminPage) {
      document.addEventListener("click", handleClickOutside);
    }

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [showCart, isAdminPage]);

  useEffect(() => {
    if (isAdminPage) {
      setShowCart(false);
    }
  }, [isAdminPage]);

  function openCart() {
    if (hideTimer.current) {
      clearTimeout(hideTimer.current);
    }
    setShowCart(true);
  }

  function closeCart() {
    if (hideTimer.current) {
      clearTimeout(hideTimer.current);
    }
    setShowCart(false);
  }

  function closeCartWithDelay() {
    if (hideTimer.current) {
      clearTimeout(hideTimer.current);
    }

    hideTimer.current = setTimeout(() => {
      setShowCart(false);
    }, 3000);
  }

  function addToCart(product) {
    const existingItem = cart.find((item) => item.id === product.id);

    if (existingItem) {
      const updatedCart = cart.map((item) =>
        item.id === product.id
          ? { ...item, quantity: item.quantity + 1 }
          : item
      );
      setCart(updatedCart);
    } else {
      setCart([...cart, { ...product, quantity: 1 }]);
    }
  }

  function increaseQuantity(productId) {
    const updatedCart = cart.map((item) =>
      item.id === productId
        ? { ...item, quantity: item.quantity + 1 }
        : item
    );
    setCart(updatedCart);
  }

  function decreaseQuantity(productId) {
    const existingItem = cart.find((item) => item.id === productId);

    if (existingItem.quantity === 1) {
      const updatedCart = cart.filter((item) => item.id !== productId);
      setCart(updatedCart);
    } else {
      const updatedCart = cart.map((item) =>
        item.id === productId
          ? { ...item, quantity: item.quantity - 1 }
          : item
      );
      setCart(updatedCart);
    }
  }

  function removeItem(productId) {
    const updatedCart = cart.filter((item) => item.id !== productId);
    setCart(updatedCart);
  }

  function clearCart() {
    setCart([]);
  }

  const totalItems = cart.reduce((sum, item) => sum + item.quantity, 0);

  const totalPrice = cart.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0
  );

  let filteredProducts = products;

  if (selectedCategory !== "All") {
    filteredProducts = filteredProducts.filter(
      (product) => product.category === selectedCategory
    );
  }

  if (search.trim() !== "") {
    filteredProducts = filteredProducts.filter((product) =>
      product.name.toLowerCase().includes(search.toLowerCase())
    );
  }

  return (
    <div
      style={{
        background: "#f7f8fa",
        minHeight: "100vh",
        position: "relative",
      }}
    >
      {!isAdminPage && (
        <Header
          search={search}
          setSearch={setSearch}
        />
      )}

      <Routes>
        <Route
          path="/"
          element={
            <HomePage
              products={filteredProducts}
              addToCart={addToCart}
              setSelectedCategory={setSelectedCategory}
            />
          }
        />
        <Route
          path="/product/:id"
          element={
            <ProductDetails
              products={products}
              addToCart={addToCart}
            />
          }
        />
        <Route
          path="/checkout"
          element={
            <CheckoutPage
              cart={cart}
              totalPrice={totalPrice}
              clearCart={clearCart}
            />
          }
        />
        <Route
          path="/admin/login"
          element={<AdminLoginPage />}
        />
        <Route
          path="/admin/orders"
          element={
            <AdminRoute>
              <AdminOrdersPage />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/products"
          element={
            <AdminRoute>
              <AdminProductsPage />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/add-product"
          element={
            <AdminRoute>
              <AdminAddProductPage />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/edit-product/:id"
          element={
            <AdminRoute>
              <AdminEditProductPage />
            </AdminRoute>
          }
        />
        <Route
          path="/admin"
          element={<Navigate to="/admin/orders" replace />}
        />
        <Route
          path="/order-status"
          element={<OrderStatusPage />}
        />
        <Route
          path="/catalogue"
          element={<CataloguePage />}
        />
      </Routes>

      {!isAdminPage && !isCataloguePage && (
        <CartPanel
          cart={cart}
          showCart={showCart}
          openCart={openCart}
          closeCart={closeCart}
          closeCartWithDelay={closeCartWithDelay}
          totalItems={totalItems}
          totalPrice={totalPrice}
          increaseQuantity={increaseQuantity}
          decreaseQuantity={decreaseQuantity}
          removeItem={removeItem}
        />
      )}
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
